import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PresentUser } from '@sites/data-hmm/hmm-incubator';

export const panelActions = createActionGroup({
  source: 'DashboardFeaturePresence PanelComponent',
  events: {
    init: props<{ key: string }>(),
    destroy: props<{ key: string }>(),
  },
});

export const effectsActions = createActionGroup({
  source: 'DashboardFeaturePresence Effects',
  events: {
    heartbeatSuccess: emptyProps(),
    heartbeatFailure: props<{ error: Error }>(),
    watchSuccess: props<{ presentUsers: PresentUser[] }>(),
    watchFailure: props<{ error: Error }>(),
    watchFinalize: emptyProps(),
  },
});
